import {AbstractEvent} from "@/modules/base/events";
import {Match} from "@/modules/match/entity";
import { HomeAwayType } from "../types";

export class BeforeMatchChangePossessionEvent extends AbstractEvent {
  constructor(
    public match: Match,
    public possession: HomeAwayType,
  ) {
    super();
  }
}